export class SearchedTermState {
  searchedTerm: string = '';
}
